/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CodeWrap({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M0 0h16v1H0zM1 8.5V14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h1v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8.5A2.5 2.5 0 0 1 2.5 6H14a1 1 0 1 0 0-2H0V3h14a2 2 0 1 1 0 4H2.5A1.5 1.5 0 0 0 1 8.5" /><path fill="currentColor" d="m9 8-2.5 6 .67.335 2.5-6zM3.905 10.918 5.89 8.933l-.53-.53-2.25 2.25a.375.375 0 0 0 0 .53l2.25 2.25.53-.53zM12.296 10.918 10.31 8.933l.53-.53 2.25 2.25a.375.375 0 0 1 0 .53l-2.25 2.25-.53-.53z" /></svg>;
}
;